import axios from 'axios';
import { VehicleBlueBookRate } from '../types/Vehicle';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

class VehicleBlueBookRateService {
  private handleError(error: any): Error {
    if (error.response) {
      const message = error.response.data?.error || error.response.data?.message || 'An error occurred';
      return new Error(message);
    } else if (error.request) {
      return new Error('No response from server. Please check your connection.');
    } else {
      return new Error(error.message || 'An unexpected error occurred');
    }
  }

  async getRates(vehicleId: number): Promise<VehicleBlueBookRate[]> {
    try {
      const response = await axios.get(`${BASE_URL}/vehicles/${vehicleId}/bluebook-rates`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getCurrentRate(vehicleId: number): Promise<VehicleBlueBookRate | null> {
    try {
      const response = await axios.get(`${BASE_URL}/vehicles/${vehicleId}/bluebook-rates/current`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createRate(vehicleId: number, data: Partial<VehicleBlueBookRate>): Promise<VehicleBlueBookRate> {
    try {
      const response = await axios.post(`${BASE_URL}/vehicles/${vehicleId}/bluebook-rates`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateRate(vehicleId: number, id: number, data: Partial<VehicleBlueBookRate>): Promise<VehicleBlueBookRate> {
    try {
      const response = await axios.put(`${BASE_URL}/vehicles/${vehicleId}/bluebook-rates/${id}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteRate(vehicleId: number, id: number): Promise<void> {
    try {
      await axios.delete(`${BASE_URL}/vehicles/${vehicleId}/bluebook-rates/${id}`);
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new VehicleBlueBookRateService();
